import { useCoursesStore } from "../../modules/Courses/stores/courseStore";
import { useEssayCourseStore } from "../../modules/Courses/stores/essayStore";
import { useRevisionStore } from "../../modules/Courses/stores/revisionStore";
import { useThemeStore } from "../../modules/Courses/stores/themeStore";
import { useDisciplineStore } from "../../modules/Disciplines/stores/disciplineStore";
import { useExercisePrintStore } from "../../modules/Disciplines/stores/exercisePrintStore";
import { useExerciseStore } from "../../modules/Disciplines/stores/exercisesStore";
import { useLessonContentStore } from "../../modules/Disciplines/stores/lessonContentStore";
import { useLessonStore } from "../../modules/Disciplines/stores/lessonStore";
import { useMaterialStore } from "../../modules/Disciplines/stores/materialStore";
import { useModuleStore } from "../../modules/Disciplines/stores/moduleStore";
import { usePodcastStore } from "../../modules/Disciplines/stores/podcastsStore";
import { useSubjectStore } from "../../modules/Disciplines/stores/subjectStore";
import { useCreateEssayStore } from "../../modules/Essay/stores/createEssayStore";
import { useUserEssayStore } from "../../modules/Essay/stores/essayByUser";
import { useEssayFilterStore } from "../../modules/Essay/stores/essayFilterStore";
import { useEssayImageStore } from "../../modules/Essay/stores/essayImageStore";
import { meEssayStore } from "../../modules/Essay/stores/meEssayStore";
import { useSendEssayStore } from "../../modules/Essay/stores/sendEssayStore";
import { useThemeFilterStore } from "../../modules/Essay/stores/themeFilterStore";
import { favoriteFilterStore } from "../../modules/Favorites/stores/favoriteFilterStore";
import { useMyEventsStore } from "../../modules/MyArea/stores/myEventsStore";
import { useRecentContentStore } from "../../modules/MyArea/stores/recentContentStore";
import { useLessonHighlightStore } from "../../modules/MyArea/stores/useLessonHighlight";
import { useOnboardingStore } from "../../modules/Onboarding/stores/onboardingStore";
import { searchFilterStore } from "../../modules/Search/stores/searchFilters";

export const resetAll = () => {
    const resetEssayCourse = useEssayCourseStore.getState().resetEssayCourse;
    const resetEssayImage  = useEssayImageStore.getState().resetEssayImage;
    const resetCourses  = useCoursesStore.getState().resetCourses;
    const resetThemeCourse  = useThemeStore.getState().resetThemeCourse;
    const resetDiscipline  = useDisciplineStore.getState().resetDiscipline;
    const resetExercises  = useExerciseStore.getState().resetExercises;
    const resetExercisePrint  = useExercisePrintStore.getState().resetExercisePrint;
    const resetLessonContent  = useLessonContentStore.getState().resetLessonContent;
    const resetLesson  = useLessonStore.getState().resetLesson;
    const resetMaterial  = useMaterialStore.getState().resetMaterial;
    const resetModule  = useModuleStore.getState().resetModule;
    const resetPodcast  = usePodcastStore.getState().resetPodcast;
    const resetSubject  = useSubjectStore.getState().resetSubject;
    const resetCreateEssay  = useCreateEssayStore.getState().resetCreateEssay ;
    const resetUserEssay  = useUserEssayStore.getState().resetUserEssay;
    const resetSendEssay  = useSendEssayStore.getState().resetSendEssay;
    const resetCredits  = meEssayStore.getState().resetCredits;
    const resetEvent  = useMyEventsStore.getState().resetEvent;
    const resetRecentContent  = useRecentContentStore.getState().resetRecentContent;
    const resetLessonHighlight  = useLessonHighlightStore.getState().resetLessonHighlight;
    const resetOnboarding  = useOnboardingStore.getState().resetOnboarding;
    const resetReview = useRevisionStore.getState().resetReview;
    const resetFiltersEssay = useEssayFilterStore.getState().reset;
    const resetFilterTheme = useThemeFilterStore.getState().reset;
    const resetFavorites = favoriteFilterStore.getState().resetFilter;
    const resetSearch = searchFilterStore.getState().resetFilterSearch;
    
    resetEssayCourse();
    resetEssayImage();
    resetCourses();
    resetThemeCourse();
    resetDiscipline();
    resetExercises();
    resetExercisePrint();
    resetLessonContent();
    resetLesson();
    resetMaterial();
    resetModule();
    resetPodcast();
    resetSubject();
    resetCreateEssay();
    resetUserEssay();
    resetSendEssay();
    resetCredits();
    resetEvent();
    resetRecentContent();
    resetLessonHighlight();
    resetOnboarding();
    resetReview();
    resetFiltersEssay();
    resetFilterTheme();
    resetFavorites();
    resetSearch();
  }
